import React, { useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';

const MaintenanceCompanyFormModal = ({ visible, onCancel, onSubmit, editingCompany, isLoading }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            if (editingCompany) {
                form.setFieldsValue({
                    name: editingCompany.name,
                    contactPhone: editingCompany.contactPhone,
                    contactEmail: editingCompany.contactEmail,
                    address: editingCompany.address,
                    contactPerson: editingCompany.contactPerson,
                    contactPersonPhone: editingCompany.contactPersonPhone,
                    contactPersonEmail: editingCompany.contactPersonEmail,
                });
            } else {
                form.resetFields();
            }
        }
    }, [visible, editingCompany, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            await onSubmit(values);
            if (!isLoading) {
                form.resetFields();
            }
        } catch (err) {
            console.error('Submission error:', err);
        }
    };

    return (
        <Modal
            title={editingCompany ? 'Edit Maintenance Company' : 'Add Maintenance Company'}
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={isLoading}>
                    Cancel
                </Button>,
                <Button
                    key="save"
                    type="primary"
                    onClick={handleSubmit}
                    loading={isLoading}
                    style={{ backgroundColor: '#298d9f', borderColor: '#298d9f' }}
                >
                    Save
                </Button>,
            ]}
            destroyOnClose
            width={600}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Company Name"
                    rules={[
                        { required: true, message: 'Please enter company name' },
                        { max: 100, message: 'Name cannot exceed 100 characters' }
                    ]}
                >
                    <Input placeholder="Enter company name" />
                </Form.Item>

                <Form.Item
                    name="contactPhone"
                    label="Contact Phone"
                    rules={[
                        { required: true, message: 'Please enter contact phone' },
                        { pattern: /^[0-9+\-() ]+$/, message: 'Please enter a valid phone number' }
                    ]}
                >
                    <Input placeholder="Enter contact phone" />
                </Form.Item>

                <Form.Item
                    name="contactEmail"
                    label="Contact Email"
                    rules={[
                        { required: true, message: 'Please enter contact email' },
                        { type: 'email', message: 'Please enter a valid email' }
                    ]}
                >
                    <Input placeholder="Enter contact email" />
                </Form.Item>

                <Form.Item
                    name="address"
                    label="Address"
                    rules={[
                        { required: true, message: 'Please enter address' },
                        { max: 200, message: 'Address cannot exceed 200 characters' }
                    ]}
                >
                    <Input.TextArea
                        rows={2}
                        placeholder="Enter company address"
                    />
                </Form.Item>

                <div className="border-t pt-4 mt-4">
                    <h3 className="text-base font-semibold mb-3 text-gray-700">Contact Person Details</h3>
                    
                    <Form.Item
                        name="contactPerson"
                        label="Contact Person Name"
                        rules={[
                            { required: true, message: 'Please enter contact person name' },
                            { max: 100, message: 'Name cannot exceed 100 characters' }
                        ]}
                    >
                        <Input placeholder="Enter contact person name" />
                    </Form.Item>

                    <Form.Item
                        name="contactPersonPhone"
                        label="Contact Person Phone"
                        rules={[
                            { required: true, message: 'Please enter contact person phone' },
                            { pattern: /^[0-9+\-() ]+$/, message: 'Please enter a valid phone number' }
                        ]}
                    >
                        <Input placeholder="Enter contact person phone" />
                    </Form.Item>

                    <Form.Item
                        name="contactPersonEmail"
                        label="Contact Person Email"
                        rules={[
                            { required: true, message: 'Please enter contact person email' },
                            { type: 'email', message: 'Please enter a valid email' }
                        ]}
                    >
                        <Input placeholder="Enter contact person email" />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
};

export default MaintenanceCompanyFormModal;